import {useMemo, useRef} from 'react';

import objectHash from 'object-hash';
import {isDeepEqual} from 'src/utils/isDeepEqual';

import type {InteractiveColumn} from './typedef';
import type {RowData} from '@pb/kit-component-data-table-v2';


type Props = {
    columns: Array<InteractiveColumn>,
    dataRows: RowData[],
};

export const useUpdateTable = ({columns, dataRows}: Props) => {
    const columnsIdsRef = useRef<Array<string>>([]);
    const interactionColumnsIdsRef = useRef<Array<string>>([]);
    const entityIdsRef = useRef<Array<string>>([]);

    const {allColumnsIds, columnsIds, interactionColumnsIds} = useMemo(() => {
        const _allColumnsIds: string[] = [];
        const _columnsIds: string[] = [];
        const _interactionColumnsIds: string[] = [];

        for (const column of columns) {
            if (column.columnType) {
                _interactionColumnsIds.push(column.columnId);
            }
            _allColumnsIds.push(column.columnId);
        }

        columnsIdsRef.current = _columnsIds;

        const newInteractionColumnsIds = isDeepEqual({
            prev: _interactionColumnsIds,
            current: interactionColumnsIdsRef.current,
        }) ? interactionColumnsIdsRef.current : _interactionColumnsIds;

        interactionColumnsIdsRef.current = newInteractionColumnsIds;

        return {
            columnsIds: _columnsIds,
            allColumnsIds: _allColumnsIds,
            interactionColumnsIds: newInteractionColumnsIds,
        };
    }, [columns]);

    const key = useRef<string>(objectHash({allColumnsIds}));

    const {entityIds} = useMemo(() => {
        const _entityIds: string[] = [];


        for (const row of dataRows) {
            _entityIds.push(row.id as string);
        }

        entityIdsRef.current = isDeepEqual({prev: _entityIds, current: entityIdsRef.current})
            ? entityIdsRef.current
            : _entityIds;

        return {
            entityIds: _entityIds,
        };
    }, [dataRows]);

    return {
        key,
        entityIds,
        columnsIds,
        allColumnsIds,
        interactionColumnsIds,
    };
};
